module.exports = __webpack_public_path__ + "media/clip_8.300091d5.mp4";